import { open } from './Snackbar.svelte'

export default {
    open: (msg) => {
        open(msg)
    }
}